import React from 'react'
import PropTypes from 'prop-types'

import GreetingPopup from './GreetingPopup'

class StartPopup extends React.Component {
  closePopup = e => {
    e.stopPropagation()
    this.props.closePopup()
  }

  render() {
    const {text, submitPopup} = this.props
    return (
      <GreetingPopup
        dataTest={'pop-up-msg-close'}
        handleClosePopup={this.closePopup}
        handleSubmitPopup={() => submitPopup(true)}
        text={text}
      />
    )
  }
}

StartPopup.propTypes = {
  submitPopup: PropTypes.func,
  closePopup: PropTypes.func,
}

export default StartPopup
